// @flow
import _ from 'lodash';
import type { BundleState } from 'src/models/bundle';

import {
  CREATE_PREDICTIVE_BUNDLE_WIDGET_FAILURE,
  CREATE_PREDICTIVE_BUNDLE_WIDGET_REQUEST,
  CREATE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS,
  DELETE_PREDICTIVE_BUNDLE_WIDGET_FAILURE,
  DELETE_PREDICTIVE_BUNDLE_WIDGET_REQUEST,
  DELETE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS,
  GET_PREDICTIVE_BUNDLE_LIST_FAILURE,
  GET_PREDICTIVE_BUNDLE_LIST_REQUEST,
  GET_PREDICTIVE_BUNDLE_LIST_SUCCESS,
  GET_PREDICTIVE_BUNDLE_WIDGET_FAILURE,
  GET_PREDICTIVE_BUNDLE_WIDGET_REQUEST,
  GET_PREDICTIVE_BUNDLE_WIDGET_SUCCESS,
  GET_SYNC_ORDER_STATUS_BUNDLE_FAILURE,
  GET_SYNC_ORDER_STATUS_BUNDLE_REQUEST,
  GET_SYNC_ORDER_STATUS_BUNDLE_SUCCESS,
  SYNC_BUNDLE_WIDGETS_FAILURE,
  SYNC_BUNDLE_WIDGETS_REQUEST,
  SYNC_BUNDLE_WIDGETS_SUCCESS,
  UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_FAILURE,
  UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_REQUEST,
  UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_SUCCESS,
  UPDATE_PREDICTIVE_BUNDLE_WIDGET_FAILURE,
  UPDATE_PREDICTIVE_BUNDLE_WIDGET_REQUEST,
  UPDATE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS,
  GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_REQUEST,
  GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_SUCCESS,
  GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_FAILURE,
  RESET_PREDICTIVE_BUNDLE_WIDGET
} from 'stores/flow-type/bundle.type';
import {
  GET_NUMBER_DISCOUNT_BUNDLE_FAILURE,
  GET_NUMBER_DISCOUNT_BUNDLE_REQUEST,
  GET_NUMBER_DISCOUNT_BUNDLE_SUCCESS
} from '../flow-type/recommendation.type';

const initialState: BundleState = {
  loading: false,
  success: false,
  error: null,
  list: [],
  total: 0,
  deleting: false,
  deleteSuccess: false,
  numberDiscountBundle: 0,

  widget: {},
  saving: false,
  saveSuccess: false,
  widgetId: '',

  syncOrderStatus: {
    current: {},
    previous: {}
  },

  widgetsSyncing: false,
  widgetSyncedSuccess: false,

  defaultDesignSettingsLoading: false,
  defaultDesignSettingsLoadedSuccess: false
};
const bundleReducers = (state: BundleState = initialState, action) => {
  switch (action.type) {
    /* #region: Get recommendation widgets */
    case GET_PREDICTIVE_BUNDLE_LIST_REQUEST:
      return {
        ...state,
        success: false,
        loading: true
      };
    case GET_PREDICTIVE_BUNDLE_LIST_SUCCESS: {
      const { data = {} } = action.payload;

      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        list: data
      };
    }
    case GET_PREDICTIVE_BUNDLE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    /* #end-region */
    /* #region: Get number discount bundle */
    case GET_NUMBER_DISCOUNT_BUNDLE_REQUEST:
      return {
        ...state,
        success: false,
        loading: true
      };
    case GET_NUMBER_DISCOUNT_BUNDLE_SUCCESS: {
      const { numberDiscountBundle = 0 } = action.payload;

      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        numberDiscountBundle
      };
    }
    case GET_NUMBER_DISCOUNT_BUNDLE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    /* #end-region */

    /* #region: Get recommendation widget by id */
    case GET_PREDICTIVE_BUNDLE_WIDGET_REQUEST:
      return {
        ...state,
        success: false,
        loading: true,
        widget: {}
      };
    case GET_PREDICTIVE_BUNDLE_WIDGET_SUCCESS: {
      const { data = {} } = action.payload;
      const {
        widgetSettings = {},
        instantSearchBlockDeepLink = '',
        embedDeepLink = '',
        appBlockDeepLink = '',
        searchPageAppBlockDeepLink = '',
        productPageAppBlockDeepLink = '',
        productPageVolumeBundleAppBlockDeepLink = ''
      } = data;

      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        instantSearchBlockDeepLink,
        embedDeepLink,
        appBlockDeepLink,
        searchPageAppBlockDeepLink,
        productPageAppBlockDeepLink,
        productPageVolumeBundleAppBlockDeepLink,
        widget: widgetSettings
      };
    }
    case GET_PREDICTIVE_BUNDLE_WIDGET_FAILURE:
      return {
        ...state,
        getting: false,
        success: false,
        error: action.payload
      };
    /* #end-region */

    /* #region: CREATE dynamic bundle widget */
    case CREATE_PREDICTIVE_BUNDLE_WIDGET_REQUEST:
      return {
        ...state,
        saveSuccess: false,
        saving: true
      };
    case CREATE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS: {
      const { data = {} } = action.payload;
      const {
        widgetSettings = {},
        instantSearchBlockDeepLink = '',
        embedDeepLink = '',
        appBlockDeepLink = '',
        searchPageAppBlockDeepLink = '',
        productPageAppBlockDeepLink = '',
        productPageVolumeBundleAppBlockDeepLink = ''
      } = data;
      return {
        ...state,
        saving: false,
        saveSuccess: true,
        widget: widgetSettings,
        embedDeepLink,
        appBlockDeepLink,
        instantSearchBlockDeepLink,
        searchPageAppBlockDeepLink,
        productPageAppBlockDeepLink,
        productPageVolumeBundleAppBlockDeepLink,
        total: state.total + 1,
        error: undefined
      };
    }
    case CREATE_PREDICTIVE_BUNDLE_WIDGET_FAILURE:
      return {
        ...state,
        saveSuccess: false,
        saving: false,
        error: action.payload
      };
    /* #end-region */

    /* #region: Update recommendation widget */
    case UPDATE_PREDICTIVE_BUNDLE_WIDGET_REQUEST:
      return {
        ...state,
        saveSuccess: false,
        widgetId: '',
        saving: true
      };
    case UPDATE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS: {
      const { data = {} } = action.payload;
      const { widgetSettings = {} } = data;
      const widgetId = _.get(widgetSettings, 'id', '');
      const findIndex = state.list.findIndex(e => e.id === widgetId);
      const cloneList = _.cloneDeep(state.list);
      _.set(cloneList, `[${findIndex}].bundleStatus`, widgetSettings.bundleStatus);

      return {
        ...state,
        saving: false,
        saveSuccess: true,
        widgetId: widgetId,
        widget: widgetSettings,
        list: cloneList,
        error: undefined
      };
    }
    case UPDATE_PREDICTIVE_BUNDLE_WIDGET_FAILURE:
      return {
        ...state,
        saving: false,
        saveSuccess: false,
        error: action.payload
      };
    /* #end-region */

    /* #region: Update recommendation widget */
    case DELETE_PREDICTIVE_BUNDLE_WIDGET_REQUEST:
      return {
        ...state,
        deleteSuccess: false,
        deleting: true
      };
    case DELETE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS: {
      const { widgetId } = action.payload;
      const currentWidgets = state.list.filter(element => element.id !== widgetId);
      return {
        ...state,
        deleting: false,
        total: state.total - 1,
        list: currentWidgets,
        deleteSuccess: true,
        error: undefined
      };
    }
    case DELETE_PREDICTIVE_BUNDLE_WIDGET_FAILURE:
      return {
        ...state,
        deleting: false,
        deleteSuccess: false,
        error: action.payload
      };
    /* #endregion */

    /* #region: Update recommendation widget status */
    case UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_REQUEST:
      return {
        ...state,
        saveSuccess: false,
        saving: true
      };
    case UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_SUCCESS: {
      return {
        ...state,
        saving: false,
        saveSuccess: true,
        error: undefined
      };
    }
    case UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_FAILURE:
      return {
        ...state,
        saving: false,
        saveSuccess: false,
        error: action.payload
      };
    /* #endregion */

    /* #region: Get aiml model status by Type */
    case GET_SYNC_ORDER_STATUS_BUNDLE_REQUEST:
      return { ...state };
    case GET_SYNC_ORDER_STATUS_BUNDLE_SUCCESS: {
      const syncOrderStatus = action.payload;
      return {
        ...state,
        syncOrderStatus
      };
    }
    case GET_SYNC_ORDER_STATUS_BUNDLE_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    /* #end-region */

    /* #region: Get recommendation widgets */
    case SYNC_BUNDLE_WIDGETS_REQUEST:
      return {
        ...state,
        widgetsSyncedSuccess: false,
        widgetsSyncing: true
      };
    case SYNC_BUNDLE_WIDGETS_SUCCESS: {
      const widgets = _.get(action, 'payload.widgets', []);
      return {
        ...state,
        widgetsSyncing: false,
        widgetsSyncedSuccess: true,
        error: undefined,
        list: widgets,
        total: widgets.length
      };
    }
    case SYNC_BUNDLE_WIDGETS_FAILURE:
      return {
        ...state,
        widgetsSyncing: false,
        widgetsSyncedSuccess: false,
        error: action.payload
      };
    /* #endregion */

    /* #region: Get default design settings */
    case GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_REQUEST:
      return {
        ...state,
        defaultDesignSettingsLoading: true,
        defaultDesignSettingsLoadedSuccess: false
      };
    case GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_SUCCESS: {
      const widgetDesignShareableSettings = _.pick(action.payload, [
        'titleName',
        'titleAlignment',
        'titleFont',
        'titleFontSize',
        'titleFontStyle',
        'titleTextColor',
        'titleTextTransform',
        'templateType',
        'buttonBackgroundColor',
        'buttonTextColor'
      ]);
      return {
        ...state,
        defaultDesignSettingsLoading: false,
        defaultDesignSettingsLoadedSuccess: true,
        widgetDesignShareableSettings
      };
    }
    case GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_FAILURE:
      return {
        ...state,
        defaultDesignSettingsLoading: false,
        defaultDesignSettingsLoadedSuccess: true,
        error: action.payload
      };
    case RESET_PREDICTIVE_BUNDLE_WIDGET:
      return {
        ...initialState
      };
    /* #endregion */
    default:
      return state;
  }
};
export default bundleReducers;
